<div>

  <ng-template #timelineNodeTemplate let-value='viewData' let-date='date'>
    <div class="timeline-pay-exec-node" #payExecNode *ngIf="timelineInitialised && isInRange(date)">
      <div class="retroactivity-badge-container">
        {{isRetroSourcePayExec(filterPayExecList(value?.get(timelineData)), payExecNode)}}
        <span class="retroactivity-badge" *ngIf="selectionHasRetroPayExec(filterPayExecList(value?.get(timelineData)))">&#9415; </span>
        <span class="badge badge-pill badge-default">{{filterPayExecList(value?.get(timelineData)).length}}</span>
      </div>
      <div *ngIf="retroPayExecCount(filterPayExecList(value?.get(timelineData)))">
        <span
          class="badge badge-pill badge-retro">{{retroPayExecCount(filterPayExecList(value.get(timelineData)))}}</span>
      </div>
    </div>
  </ng-template>

  <ng-template #timelineDataInfoHeaderTemplate>
    <span> - {{payExecsDated[0].payExec.attributes.payRollSerieName | translate}}</span>
  </ng-template>

  <ng-template #timelineDataInfoTemplate>
    <div class="pay-exec-details" #payExecData (wheel)="scrollPayExecs($event, payExecData)">
      <gp-message *ngIf="!filterPayExecList(getPayExecsFromNodeSelectionData(payExecNodeSelection))?.length"
                  text="PAYROLL_RESULT.no_execution" type="info"></gp-message>

      <accordion [isAnimated]="false">
        <ng-container *ngFor="let payType of getDisplayablePayTypeKeys()">
          <accordion-group *ngIf="payExecsByPayType.get(payType)" #payTypeGroup>
            <div accordion-heading class="pay-exec-title-group">
              <span class="pay-exec-pay-type">{{displayablePayTypeTransId.get(payType) | translate}}</span>
              <em class="fa fa-light fa-lg" [ngClass]="payTypeGroup?.isOpen ? 'fa-caret-up' : 'fa-caret-down'"></em>
            </div>
            <ul>
              <li *ngFor="let payExec of payExecsByPayType.get(payType)">
                <div class="pay-exec-entry retroactivity-badge-container retroactivity-badge-container-sm"
                     [class.pay-exec-entry-selected]="isHighlightedPayExec(payExec)"
                     (click)="highlightPayExec(payExec)"
                     (dblclick)="confirmPayExecSelection()">

                <span>
                  <span *ngIf="payExec.payExec.attributes.payRollType === PayExecType.RETROACTIVITY"
                        class="retroactivity-badge">&#9415; </span>
                  <span
                    *ngIf="payExec.payExec.attributes.payRollType === PayExecType.RETROACTIVITY && payExec.payExec.attributes.originePayExecPayrollPeriodsName">
                    {{ payExec.payExec.attributes.originePayExecPayrollPeriodsName }},
                  </span>
                  <span>{{ payExec.payExec.attributes.shortId }}</span>
                  <span> {{ payExec.payExec.attributes.payState.computeDate | amTimezoneOffset | amDateFormat:'(MM/DD HH:mm)'}}</span>
                </span>
                  <span class="pay-exec-entry-error tag tag-pill tag-danger"
                        *ngIf="payExec.payExec.attributes.payState.status === 'ERROR'">!</span>
                </div>
              </li>
            </ul>
          </accordion-group>
        </ng-container>
      </accordion>
    </div>
  </ng-template>

  <div *ngIf="employee && !loading">
    <div class="clearfix top-header">
      <gp-employee-top-card [employee]="employee"
                            [selectedContract]="selectedContract"
                            [hiddenItems]="{seePayrollResults: true, certificates: true, communication: true}"
                            (selectedContractChange)="onContractSelected($event)"
                            (payrollStatusChanged)="payrollStatusChanged($event)">
        <div class="gp-pull-right pay-exec-selection-info" *ngIf="timelineInitialised && selectedPayExec">
          <div class="text-center">
            <div class="pull-left">
              <div>
                {{ selectedPayExec.attributes.payRollPeriodsName | translate}}
                -
                {{ selectedPayExec.attributes.payRollSerieName | translate}}
              </div>
              <div class="pay-exec-selection-info-label retroactivity-badge-container">
                <span *ngIf="selectedPayExec.attributes.payRollType === PayExecType.RETROACTIVITY"
                      class="retroactivity-badge">&#9415; </span>
                <span>{{ selectedPayExec.attributes.payPeriodContractPayTypeTransId | translate }}: </span>
                <span
                  *ngIf="selectedPayExec.attributes.payRollType === PayExecType.RETROACTIVITY && selectedPayExec.attributes.originePayExecPayrollPeriodsName">
                  {{ selectedPayExec.attributes.originePayExecPayrollPeriodsName }},
                </span>
                <span>{{ selectedPayExec.attributes.shortId }}</span>
                <span> {{ selectedPayExec.attributes.payState.computeDate | amTimezoneOffset | amDateFormat:'(MM/DD HH:mm)'}}</span>
              </div>
            </div>
          </div>
        </div>
      </gp-employee-top-card>

      <div class="pay-exec-timeline" *ngIf="timelineLandingDate">
        <div class="row">
          <gp-horizontal-timeline [config]="timelineConfig"
                                  [selectedDateView]="timelineLandingDate"
                                  [timelineDataSet]="timelineDataSet"
                                  [dataSegmentHandler]="timelineDataHandler"
                                  [timelineNodeTemplate]="timelineNodeTemplate"
                                  [shouldCloseOpenedViewCard]="shouldCloseOpenedViewCard"
                                  [selectedNodeTemplate]="timelineDataInfoTemplate"
                                  [selectedNodeHeaderTemplate]="timelineDataInfoHeaderTemplate"
                                  [timelineLoading]="timelineLoading"
                                  [selectedNodeLoading]="timelineInfoLoading"
                                  (initialised)="onPayExecTimelineInitialised($event)"
                                  (previous)="onLoadPreviousPayExecs($event)"
                                  (selected)="onPayExecNodeSelection($event)">
          </gp-horizontal-timeline>
        </div>
      </div>
    </div>

    <div class="row no-margin">
      <div class="employee-detail-content" *ngIf="!loading && selectedPayExec && selectedContract">
        <div class="nav-active-bg">
          <tabset #payResultTabset>

            <!-- Overview -->
            <tab heading="{{'PAYROLL_RESULT.overview' | translate}}"
                 id="Overview"
                 #tabOverview
                 [customClass]="!isInternationalPayslipAvailable() ? 'display-disabled' : ''"
                 (selectTab)="onTabSelected('Overview')"
                 [active]="isTabActive('Overview')">
              <div class="text-center p-t-lg p-b-lg padding" *ngIf="!isInternationalPayslipAvailable()">
                <div class="alert alert-warning" *ngIf="getLastPayExecWithOverview()">
                  <strong>{{ 'PAYROLL_RESULT.overview_disabled' | translate }}
                  </strong>
                  <!--<span class="btn-link text-primary alert-link pointer"-->
                  <!--(click)="redirectToLastPayExecWithOverview()">-->
                  <!--{{'PAYROLL_RESULT.overview_click_here' | translate}}-->
                  <!--</span>-->
                </div>
                <div class="alert alert-warning" *ngIf="!getLastPayExecWithOverview()">
                  <strong>{{ 'PAYROLL_RESULT.all_overview_disabled' | translate }}</strong>
                </div>
              </div>
              <gp-pay-result-overview class="pay-result-overview"
                                      *ngIf="readyTabs['Overview'] && isInternationalPayslipAvailable()"
                                      [currency]="payExecLog?.data?.attributes?.currencyString"
                                      [calculateDate]="payExecLog?.data?.attributes?.payState?.computeDate"
                                      [payExecId]="selectedPayExec?.id">
              </gp-pay-result-overview>
            </tab>

            <!-- Payslip -->
            <tab heading="{{'PAYROLL_RESULT.payslip' | translate}}"
                 id="Payslip"
                 #payslip
                 [customClass]=" !hasPayslip(selectedPayExec) ? 'display-disabled' : ''"
                 (selectTab)="onTabSelected('Payslip')"
                 [active]="isTabActive('Payslip')">
              <gp-payslip *ngIf="readyTabs['Payslip'] && hasPayslip(selectedPayExec)"
                          [locale]="payExecLog?.data?.attributes?.localeString"
                          [currency]="payExecLog?.data?.attributes?.currencyString"
                          [selectedPayExec]="selectedPayExec"
                          [payExecId]="selectedPayExec?.id"
                          [payPeriodId]="payPeriodId"
                          [cliRegId]="selectedContract?.cliRegID"
                          [contractId]="selectedContract?.id"
                          [isPayrollStatusLoading]="isPayrollStatusLoading"
                          [payslipHtmlFileId]="payslipHtmlFileId"
                          [payslipPdfFileId]="payslipPdfFileId"
                          (selectPayExec)="changeSelectedPayExec($event)">
              </gp-payslip>
              <div class="text-center p-t-lg p-b-lg padding" *ngIf="!hasPayslip(selectedPayExec)">
                <gp-message [text]="'PAYROLL_RESULT.payslip_tab_disabled'"
                            [type]="'info'">
                </gp-message>
              </div>
            </tab>

            <!-- Retro payslips -->
            <tab heading="{{'PAYROLL_RESULT.retro_payslips_tab_title' | translate}}"
                 id="RetroPayslips"
                 (selectTab)="onTabSelected('RetroPayslips')"
                 [active]="isTabActive('RetroPayslips')"
                 [customClass]="hasRetroPayslips() ? '' : 'hide'">
              <gp-retro-payslips *ngIf="readyTabs['RetroPayslips'] && hasRetroPayslips()"
                                 [payExecId]="selectedPayExec?.id"
                                 (selectPayExec)="changeSelectedPayExec($event)">
              </gp-retro-payslips>
              <div class="text-center p-t-lg p-b-lg padding" *ngIf="!hasRetroPayslips()">
                <gp-message [text]="'PAYROLL_RESULT.retro_payslips_tab_disabled'"
                            [type]="'info'">
                </gp-message>
              </div>
            </tab>

            <!-- Payroll results -->
            <tab heading="{{'PAYROLL_RESULT.payroll_result' | translate}}"
                 id="Payroll result"
                 (selectTab)="onTabSelected('Payroll result')"
                 [active]="isTabActive('Payroll result')">
              <gp-results *ngIf="readyTabs['Payroll result']"
                          [locale]="payExecLog?.data?.attributes?.localeString"
                          [currency]="payExecLog?.data?.attributes?.currencyString"
                          [isAdministrator]="isAdministrator"
                          [payExecId]="selectedPayExec?.id"
                          [cliRegId]="selectedContract?.cliRegID"
                          [contractId]="selectedContract?.id"
                          [payPeriodId]="payPeriodId"
                          [highlight]="highlight">
              </gp-results>
            </tab>

            <!-- Retro value -->
            <tab heading="{{'PAYROLL_RESULT.retro_tab_title' | translate}}"
                 id="RetroValues"
                 (selectTab)="onTabSelected('RetroValues')"
                 [active]="isTabActive('RetroValues')"
                 [customClass]="retroValue?.length ? '' : 'hide'">
              <gp-retro-values *ngIf="readyTabs['RetroValues']"
                               [retroValues]="retroValue"
                               [currency]="payExecLog?.data?.attributes?.currencyString">
              </gp-retro-values>
            </tab>

            <!-- Comparison -->
            <tab heading="{{'PAYROLL_RESULT.payroll_comparison' | translate}}"
                 id="Comparison"
                 (selectTab)="onTabSelected('Comparison')"
                 [active]="isTabActive('Comparison')">
              <gp-pay-comparison *ngIf="readyTabs['Comparison']"
                                 [locale]="payExecLog?.data?.attributes?.localeString"
                                 [currency]="payExecLog?.data?.attributes?.currencyString"
                                 [contractId]="selectedContract?.id">
              </gp-pay-comparison>
            </tab>

            <!-- Aggregates -->
            <tab heading="{{'PAYROLL_RESULT.aggregates' | translate}}"
                 id="Aggregates"
                 (selectTab)="onTabSelected('Aggregates')"
                 [active]="isTabActive('Aggregates')"
                 [customClass]="!lastGoodExecutionIds.includes(selectedPayExec.id) ? 'display-disabled' : ''">
              <div
                *ngIf="!payExecUtilsPublic.isGoodPayExec(selectedPayExec); else isCorrectPayExec"
                class="text-center p-t-lg p-b-lg padding">
                <gp-message [text]="'PAYROLL_ANALYZE.aggregates_tab_disabled'"
                            [type]="'info'">
                </gp-message>
              </div>
              <ng-template #isCorrectPayExec>
                <gp-aggregates
                  *ngIf="readyTabs['Aggregates']"
                  [aggregatesType]="'individual'"
                  [aggregatesId]="selectedContract?.id"
                  [payPeriodId]="payPeriodId"
                  [isReadOnly]="isReadOnly || selectedContract.readOnly"
                  [highlight]="highlight"
                  [initialAggregates]="isSelectedExecPayRollTypeNormal()">
                </gp-aggregates>
              </ng-template>
            </tab>

            <!-- Calendar -->
            <tab heading="{{'PAYROLL_RESULT.calendar' | translate}}"
                 id="Calendar"
                 (selectTab)="onTabSelected('Calendar');"
                 [active]="isTabActive('Calendar')">
              <gp-pay-result-calendar *ngIf="readyTabs['Calendar']"
                                      [payExecId]="selectedPayExec?.id">
              </gp-pay-result-calendar>
            </tab>

            <!-- Technical logs -->
            <tab *ngIf="isAdministrator"
                 id="Technical logs"
                 heading="{{'PAYROLL_RESULT.technical_logs' | translate}}"
                 (selectTab)="onTabSelected('Technical logs')"
                 [active]="isTabActive('Technical logs')">
              <gp-pay-result-log [payLog]="payExecLog?.data"></gp-pay-result-log>
            </tab>

            <!-- Dashboard -->
            <tab *ngIf="isFeatureToggleForPayrollDashboardEnabled"
                 id="Dashboard"
                 heading="{{'PAYROLL_RESULT.dashboard' | translate}}"
                 (selectTab)="onTabSelected('Dashboard')"
                 [active]="isTabActive('Dashboard')">
              <gp-payroll-dashboard
                [currency]="payExecLog?.data?.attributes?.currencyString"
                [calculateDate]="getCurrentPayExecBeginDate()"
                [payExecId]="selectedPayExec?.id"
              [contractId]="contractId"
              [payPeriodId]="payPeriodId">
              </gp-payroll-dashboard>
            </tab>

          </tabset>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!loading && !employee && !!contractId" class="padding">
    <gp-message text="FORMS.ERRORS.employee_error" type="danger"></gp-message>
  </div>
  <div *ngIf="!loading && !contracts.length && !!contractId" class="padding">
    <div class="alert alert-warning" role="alert">
      <strong>
        {{ 'PAYROLL_PREPARE.no_contract_found_for_employee' | translate:{employeeName: employee?.fullName} }}
      </strong>
    </div>
  </div>
  <div *ngIf="!loading && !selectedPayExec && !!selectedContract"
       class="padding">
    <gp-message text="PAYROLL_RESULT.no_execution_for_pay_type" type="info"
                *ngIf="payExecsDated && payExecsDated.length; else noExecutionForContract"></gp-message>
    <ng-template #noExecutionForContract>
      <gp-message text="PAYROLL_RESULT.no_execution" type="info"></gp-message>
    </ng-template>
  </div>
  <div *ngIf="loading" class="padding text-center" style="padding-top: 135px;">
    <i class="fa fa-light fa-spinner fa-spin"></i>
  </div>
</div>
